import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  BibliographicResource,
  OnlineResource,
} from '®shared/bibliographic-resource';
import { getItemElementId } from '®shared/focus';
import { ExternalLinkClickEvent } from '®shared/list-item/events';
import { EditableItem } from '®shared/reading-list/models/editable-item';

import { BookstoreAndAvailability } from './bookstore';
import { LoadableLibraryAvailability } from './library';

@Component({
  selector: 'rl-combined-availability',
  templateUrl: './combined-availability.component.html',
})
export class CombinedAvailabilityComponent {
  @Input() depth = 0;
  @Input() resource: BibliographicResource;
  @Input() physicalAvailability: LoadableLibraryAvailability;
  @Input() bookstoresAvailability: BookstoreAndAvailability[];
  @Input() digitisationLink?: string;
  @Input() item: EditableItem;
  @Input() onlineResource: OnlineResource;
  @Output() onlineResourceClick = new EventEmitter<ExternalLinkClickEvent>();

  /**
   * Get the aria level for the "Availability" heading.
   * This will be one level higher than the item heading level,
   * which must begin at level 2 since the page title uses <h1>
   *
   * - Page title (level = 1)
   * ...
   * - - Item title (level = depth + 2)
   * - - - Availability (level = depth + 3)
   *
   * @returns number
   */
  get ariaHeadingLevel(): number {
    return this.depth + 3;
  }

  /**
   * Whether there is non-library availability of the resource.
   * This controls the visibility of the 'Alternative availability'
   * panel on the expanded item view.
   *
   * @returns boolean
   */
  get hasAlternativeAvailability(): boolean {
    const bookstoresAvailabilityCount =
      this.bookstoresAvailability == null
        ? 0
        : this.bookstoresAvailability.length;

    const isGoogleBook = this.onlineResource?.type === 'google_books';
    return bookstoresAvailabilityCount > 0 || isGoogleBook;
  }

  get showGooglePreviewButton() {
    return this.onlineResource?.type === 'google_books';
  }

  get itemElementId(): string {
    return getItemElementId(this.item.id);
  }
}
